<div class="ui-accordion-panel">
  <div class="ui-accordion-header" (click)="toggle()" tabindex="0">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="ui-accordion-content" [collapse]="!isOpen"> <!--[collapse]="!isOpen" FIXME(ng2)-->
    <ng-content class="content-wrapper" select="[content]"></ng-content>
  </div>
</div>